import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('glacier_keep', {
  cherry: 'ice_shield',
  lemon: 'frost_sword',
  orange: 'ice_key',
  bell: 'keep_bell',
  star: 'ice_throne_wild',
  seven: 'ice_castle',
  gem: 'frost_sapphire',
  scatter: 'ice_sigil_scatter',
  money: 'frozen_hoard',
});

/** Glacier Keep — GENERATED by scaffoldSlot from
 *  content/slots/glacier_keep.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const GLACIER_KEEP_THEME: Theme = {
  id: 'glacier_keep',
  name: 'Glacier Keep',
  palette: {
    accent: 0x3e78b0,
    secondary: 0x9ec0e0,
    warm: 0xf2d27a,
    frameFill: 0x141f2e,
    bgGradientTop: 0x213650,
    bgGradientBottom: 0x080f1a,
    dimOverlay: 0x04070f,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Ice Shield', glyph: '🛡️', tint: 0x6f9ac8, weight: 5, textureAlias: 'glacier_keep:cherry',
        winVideoAlias: 'glacier_keep:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Frost Sword', glyph: '🗡️', tint: 0xbcd4e8, weight: 5, textureAlias: 'glacier_keep:lemon',
        winVideoAlias: 'glacier_keep:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Ice Key', glyph: '🗝️', tint: 0xd0b070, weight: 4, textureAlias: 'glacier_keep:orange',
        winVideoAlias: 'glacier_keep:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Keep Bell', glyph: '🔔', tint: 0xd0a84e, weight: 3, textureAlias: 'glacier_keep:bell',
        winVideoAlias: 'glacier_keep:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Ice Throne', glyph: '👑', tint: 0x8fc0e8, weight: 2, textureAlias: 'glacier_keep:star',
        winVideoAlias: 'glacier_keep:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Glacier Keep', glyph: '🏰', tint: 0x5f8fc0, weight: 2, textureAlias: 'glacier_keep:seven',
        winVideoAlias: 'glacier_keep:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Frost Sapphire', glyph: '💎', tint: 0x3e78b0, weight: 2.5, textureAlias: 'glacier_keep:gem',
        winVideoAlias: 'glacier_keep:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Frost Sigil', glyph: '❄️', tint: 0xc8dcf0, weight: 0.5, textureAlias: 'glacier_keep:scatter',
        winVideoAlias: 'glacier_keep:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Frozen Hoard', glyph: '💰', tint: 0xf0c860, weight: 1, textureAlias: 'glacier_keep:money',
        winVideoAlias: 'glacier_keep:money:win:video', winVideoSpeed: 2, isMoney: true },
      // Gem-on-reel — producer brief 2026-06-04. Scatter-style bonus
      // shared across every biome (registered via SHARED_REEL_SYMBOLS
      // in themes/index.ts). Weights deliberately rare so a gem
      // landing feels like a treat rather than background noise.
      { id: 'gem_t5',  label: 'Gems',     glyph: '💎', tint: 0x3ea7e8, weight: 0.10, gemValue: 5,  textureAlias: 'shared:reel:gem_5' },
      { id: 'gem_t10', label: 'Gem Pile', glyph: '💎', tint: 0x3ea7e8, weight: 0.05, gemValue: 10, textureAlias: 'shared:reel:gem_10' },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x141f2e, multiplier: 0, weight: 4 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0x3e78b0, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x141f2e, multiplier: 0, weight: 3 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0x9ec0e0, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0x3e78b0, multiplier: 1, weight: 3 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x0-c', kind: 'multiplier', label: '✕', tint: 0x141f2e, multiplier: 0, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 2 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0x3e78b0, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x25-a', kind: 'multiplier', label: '×25', tint: 0xf2d27a, multiplier: 25, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'glacier_keep:bg', path: 'environment/glacier_keep.png' },
      columnBackground: { alias: 'glacier_keep:column_bg', path: 'reel/glacier_keep_column_bg.png' },
      border: { alias: 'glacier_keep:border', path: 'brand/border_frost.png' },
    },
  },
};
